import $ from 'jquery';
import { els } from './variables';
import { scrollToEl, forceLazyLoad, getUrlParamter } from '../global/helpers';
import { initImageLightBox, initVideoLightbox } from './lightboxes';

// Minimum delay (in milliseconds) to wait before loading in new posts.
const minDelay = 1000;
// Array of heading tags.
const headingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
// Scroll to the top of the post list, or the previous heading tag if present.
const scrollToPostList = (postList) => {
	const prevEl = postList.previousElementSibling;
	const elToScrollTo = prevEl && headingTags.indexOf(prevEl.tagName.toLowerCase()) !== -1 ? prevEl : postList;
	scrollToEl(elToScrollTo, els.headerInner.offsetHeight + 30);
};

function loadPosts(requestURL, postList) {
	// Start timing this function.
	const start = window.performance.now();
	// Add loading class so the user knows something is happening.
	postList.classList.add('loading');
	// Make the request and load new posts within the postList element.
	$.get(requestURL, (html) => {
		// Get the post list element from the returned HTML.
		const $newPostList = $(`#${postList.id}`, html);
		if ($newPostList.length) {
			// Stop timing this function.
			const end = window.performance.now();
			// Get the elapsed time, in milliseconds.
			const diff = end - start;
			// See if the elapsed time is less than our minimum delay value,
			// and if so, create a delay that will bring us to that minimum value.
			const delay = diff < minDelay ? diff + (minDelay - diff) : 0;
			setTimeout(() => {
				// Update the URL with the requestURL, so that the user can refresh the page or share.
				window.history.pushState({
					requestURL,
					postListId: postList.id,
				}, '', requestURL);
				// Inject the new post list html into the current one.
				postList.innerHTML = $newPostList.html();
				// Force images to load.
				forceLazyLoad(postList);
				// Scroll to the top of the post list, or the previous heading tag if present.
				scrollToPostList(postList);
				// Initialize lightboxes on new elements.
				initImageLightBox();
				initVideoLightbox();
				// Remove the loading class.
				postList.classList.remove('loading');
			}, delay);
		}
	});
}

document.addEventListener('click', (e) => {
	// Check if the clicked element is, or belongs to, a pagination link.
	const pageNumber = e.target.closest('a.page-numbers');
	if (pageNumber) {
		// Check to see if that pagination link belongs to a post list block.
		const postList = pageNumber.closest('.em-post-list');
		if (postList) {
			// Prevent the link from refreshing the page.
			e.preventDefault();
			// Pass the postList.id value into the request URL so that only this block is paged.
			const queryString = `?block=${postList.id}`;
			const requestURL = pageNumber.href.indexOf(queryString) === -1 ? `${pageNumber.href}${queryString}` : pageNumber.href;
			loadPosts(requestURL, postList);
		}
	}
});

window.addEventListener('load', () => {
	// Get the "block" param from the current URL.
	const blockId = getUrlParamter('block');
	if (blockId) {
		// If it exists, then use it to get the postList element with that same ID.
		const postList = document.getElementById(blockId);
		if (postList) {
			// If the element exists, scroll to it.
			scrollToPostList(postList);
		}
	}
});

// Reload the page if the browser back button is hit and there has been a state added to the history.
window.addEventListener('popstate', () => {
	const clinicalTrials = document.querySelector('.em-clinical-trials');

	if (clinicalTrials) {
		window.location.reload();
	}
});
